import React from "react";

const TermsCondn = () => {
  return (
    <div className="bg-gray-100 h-[300vh]">
      <div className="max-w-[1080px] bg-white text-black w-full shadow-lg shadow-white-100 mx-auto ">
        <div className="py-7">
          <h1 className="text-center text-3xl font-bold italic ">
            TERMS AND CONDITIONS
          </h1>
          <div className="my-8 flex flex-col gap-5">
            <p
              className="text-lg font-light text-gray-900 text-justify w-[70%] mx-auto"
              style={{ lineHeight: "1.2" }}
            >
              These terms and conditions outline the rules and regulations for
              the use of recHostel.com's Website, located at redHostel.com.
            </p>
            <p
              className="text-lg font-light text-gray-900 text-justify w-[70%] mx-auto "
              style={{ lineHeight: "1.2" }}
            >
              By accessing this website we assume you accept these terms and
              conditions. Do not continue to use madewithtailwindcss.com if you
              do not agree to take all of the terms and conditions stated on
              this page.
            </p>
            <p
              className="text-lg font-light text-gray-900 text-justify w-[70%] mx-auto "
              style={{ lineHeight: "1.2" }}
            >
              The following terminology applies to these Terms and Conditions,
              Privacy Statement and Disclaimer Notice and all Agreements:
              "Client", "You" and "Your" refers to you, the person log on this
              website and compliant to the Company’s terms and conditions. "The
              Company", "Ourselves", "We", "Our" and "Us", refers to our
              Company. "Party", "Parties", or "Us", refers to both the Client
              and ourselves. All terms refer to the offer, acceptance and
              consideration of payment necessary to undertake the process of our
              assistance to the Client in the most appropriate manner for the
              express purpose of meeting the Client’s needs in respect of
              provision of the Company’s stated services, in accordance with and
              subject to, prevailing law of Netherlands. Any use of the above
              terminology or other words in the singular, plural, capitalization
              and/or he/she or they, are taken as interchangeable and therefore
              as referring to same.
            </p>
          </div>

          <div className="my-8 flex flex-col gap-5">
            <h1 className="text-3xl font-bold italic w-[70%] mx-auto">
              COOKIES
            </h1>
            <p
              className="text-lg font-light text-gray-900 text-justify w-[70%] mx-auto"
              style={{ lineHeight: "1.2" }}
            >
              We employ the use of cookies. By accessing
              madewithtailwindcss.com, you agreed to use cookies in agreement
              with the madewithtailwindcss.com's Privacy Policy.
            </p>
            <p
              className="text-lg font-light text-gray-900 text-justify w-[70%] mx-auto"
              style={{ lineHeight: "1.2" }}
            >
              Most interactive websites use cookies to let us retrieve the
              user’s details for each visit. Cookies are used by our website to
              enable the functionality of certain areas to make it easier for
              people visiting our website. Some of our affiliate/advertising
              partners may also use cookies.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsCondn;
